import { Title } from '@/components/Elements/Title/Title';
import { TextInputField, Tooltip } from '@spotted-zebra-uk/ui-components';
import { useTranslation } from 'react-i18next';
import { MicrosoftSSOButton } from '@/components/Views/Login/MicrosoftSSOButton/MicrosoftSSOButton';
import { redirectToSSOAuthentication } from '@/helpers/redirectToSSOAuthentication';
import PrivacyNotice from '@/components/Elements/PrivacyNotice/PrivacyNotice';
import { CoBrandDetails } from '../CoBrandDetails/CoBrandDetails';
import { useAuthBranding } from '@/components/Providers/BrandingProvider/BrandingProvider';

type SignUpSSOProps = {
  email?: string;
  subId: string;
  givenName?: string;
  familyName?: string;
  projectId?: string;
};

export const SignUpSSO = ({
  email,
  subId,
  givenName,
  familyName,
  projectId,
}: SignUpSSOProps) => {
  const { t } = useTranslation();

  const projectCoBranding = useAuthBranding().branding;
  const hasCoBrandingEnabled = !!projectCoBranding;

  if (!email) {
    return (
      <>
        {hasCoBrandingEnabled && (
          <CoBrandDetails projectCoBranding={projectCoBranding} />
        )}
        <Title
          title={t('login.title')}
          hasCobranding={hasCoBrandingEnabled}
          maintainSize={!hasCoBrandingEnabled}
        />
        <PrivacyNotice />
        <MicrosoftSSOButton
          onClick={async () =>
            await redirectToSSOAuthentication(subId, projectId)
          }
          text={t('login.sso.signInWithMicrosoft')}
        />
      </>
    );
  }

  return (
    <>
      {hasCoBrandingEnabled && (
        <CoBrandDetails projectCoBranding={projectCoBranding} />
      )}
      <Title title={t('login.title')} />
      <TextInputField
        id="givenName"
        value={givenName}
        label={t('forms.givenName')}
        placeholder={t('forms.givenName')}
        disabled
        onChange={() => {}}
      />
      <TextInputField
        id="familyName"
        value={familyName}
        label={t('forms.familyName')}
        placeholder={t('forms.familyName')}
        disabled
        onChange={() => {}}
      />
      <Tooltip content={t('signUp.emailLocked')}>
        <TextInputField
          id="email"
          value={email}
          label={t('forms.email')}
          placeholder={t('forms.email')}
          disabled
          onChange={() => {}}
        />
      </Tooltip>
      <PrivacyNotice />
      <MicrosoftSSOButton
        onClick={async () => await redirectToSSOAuthentication(subId)}
        text={t('login.sso.signInWithMicrosoft')}
      />
    </>
  );
};
